const { createMuiTheme } = require('@material-ui/core');

const theme = createMuiTheme({
  components: {
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: '#003366',
        },
        colorSuccess: {
          backgroundColor: '#66BB6A',
        },
        colorWarning: {
          backgroundColor: '#ffcc00',
        },
        colorError: {
          backgroundColor: '#F44336',
        },
      },
    },
  },
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#003366',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#0066ff',
      main: '#0044ff',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00',
    },
    warning: {
      main: '#ffcc00',
    },
    success: {
      main: '#66BB6A',
    },
    info: {
      main: '#003366',
    },
    error: {
      main: '#F44336',
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});

export default theme;
